import React from 'react';

import RecordsActions from '../actions/RecordsActions';
import FocusActions from '../actions/FocusActions';
import FormItemEnumEditor from "./FormItemEnumEditor";

export default class FormItemEnumRadioEditor extends FormItemEnumEditor
{
    constructor(props) 
    {
		super(props);
		this.selectedValue = "";
    }
    
    doSetModifiedTagNone(){}

    doSetModifiedTagHas(){}

    updateModifiedTag(){}
    
    selectValue(_value)
    {
        let that = this;
        $(this.radioContainer).find("input[type='radio']").each(function() {
            if($(this).attr("data-serverId") == _value) {
                //遍历radio组，使用iCheck设置选中项
                that.selectedValue = _value;
                $(this).iCheck('check');
            }
        });
    }

	onCurrentRecordChanged(records,currentRecord,groupAlias,moduleInstanceId)
	{
		super.onCurrentRecordChanged(records,currentRecord,groupAlias,moduleInstanceId);
		if(this.props.groupAlias == groupAlias && this.props.moduleInstanceId == moduleInstanceId)
		{
			this.currentDataFieldChanged = false;			
			this.doSetModifiedTagNone();
			if(this.props.dataField)
			{
				var _value = this.record?this.record[this.props.dataField]:'';
			}
			else
			{
				_value = this.record;
			}
			
			this.selectValue(_value);
			//$(this.inputField).selectpicker('val',_value);

			if(this.props.control)
			{

				var _allowEdit = true;
				if(!this.record && groupAlias)
				{
					_allowEdit = false;
				}
				else
				{
					_allowEdit = this.props.control.getProperty_AllowEdit_Final();
				}
				this.doSetEnable(_allowEdit);	
			}
		}
	}

	inputFieldFocus(e)
	{
		window.lastFocusUI = this.radioContainer;
		if(this.props.groupAlias)
			window.lastEditedDataFields[this.props.groupAlias] = this.props.dataField;
		//alert("EnumEditor inputFieldFocus");
		FocusActions.currentGroupSet(this.props.groupAlias,this.props.formId);
	}

	onDataFieldChanged(record,dataField,oldValue,newValue,observer)
	{
		if(observer != this && this.props.dataField == dataField && record == this.record)
		{
            this.selectValue(newValue);
			this.updateModifiedTag();
		}
	}

	enumRadioOnKeyDownHandler(e)
	{
		if(9===e.keyCode)
		{
			e.preventDefault();
			let index = $(e.target).attr("data-index");
			this.onTabHandler(index,e.shiftKey);
		}
    }
    
    enumRadioOnBlurHandler(e)
    {

    }

    enumRadioOnFocusHandler(e)
    {

    }

	componentDidMount()
	{
		super.componentDidMount();
		$(this.contextMenuHandler).contextPopup(this.props.contextMenuData);
		$(this.radioContainer).find('input[type="radio"].minimal').iCheck({
			radioClass: 'iradio_minimal-blue'})
		  .on('ifChecked',this.selectedChanged.bind(this,true))
		  .on('ifUnchecked',this.selectedChanged.bind(this,false));
		 
        if(this.initedSelectedValue)
        {
            this.selectValue(this.initedSelectedValue);
        }
		if(this.props.underQueryGroup)
		{
			if(this.props.control.getProperty_AllowEdit_Final()){
				this.doSetEnable(true);
			}else{
				this.doSetEnable(false);
			}
		}
		else
		{
			let _initRecord;
			if(this.props.dataField)
			{
				_initRecord = this.props.initRecord;
			}
			else
			{
				if(this.props.control.hasInitEditorValue)
				{
					_initRecord = this.props.initEditorValue;	
				}
				else
				{
					_initRecord = this.props.initRecord;
				}
				
			}
			this.onCurrentRecordChanged(null,_initRecord,this.props.groupAlias,this.props.moduleInstanceId);
		}

		//this.onCurrentRecordChanged(null,this.props.initRecord,this.props.groupAlias);
		if(!this.props.groupAlias)
		{
			this.doUpdateAllowEditByJquery(this.state.allowEdit);
		}
	}

	doSetEnable(enable)
	{
		this.setState({allowEdit:enable});
    }
    
    doUpdateAllowEditByJquery(allowEdit)
	{
		if(allowEdit == false)
		{
			$(this.radioContainer).find('input[type="radio"].minimal').iCheck('disable');
		}
		else
		{
			$(this.radioContainer).find('input[type="radio"].minimal').iCheck('enable');
		}
	}

	componentDidUpdate()
  	{
		this.doUpdateAllowEditByJquery(this.state.allowEdit);
  	}


	selectedChanged(value,e)
	{
		if(value == true && e.target)
		{
			this.selectedValue = $(e.target).attr("data-serverId");
			this.setFinalValue();
		}
	}

	setDisplay(value)
	{
		if(value == null || value == undefined)
		{
			if(this.props.dataField && this.record)
				value = this.record[this.props.dataField];
			else
				value = this.record;
		}
		this.selectValue(value);
	}

	onFocusSet(formId,itemId,pre,init)
	{
		if(this.props.formId == formId && this.props.xml.id == itemId)
		{
			let radioInputs = $(this.radioContainer).find("input[type='radio']");
			$(radioInputs[0]).focus();
			this.onTabHandler(-1,pre);
		}
    }
    
    onTabHandler(currentIndex,pre)
	{
		if(this.props.options && this.props.options.length)
		{
			let length = this.props.options.length;
			pre?currentIndex--:currentIndex++;
			if(currentIndex<0||currentIndex>=length)
			{
				//todo焦点跳出
				$(this.radioContainer).find(".iradio_minimal-blue").removeClass("gongqiFocus");
				FocusActions.focusChange(this.props.xml,pre);
			}
			else
			{
				//由于使用了基于jquery的插件 会自动更改dom 所以不能用状态管理来实现this.setState({currentTabFocusIndex:currentIndex});
				let inputList = $(this.radioContainer).find(".iradio_minimal-blue").removeClass("gongqiFocus");
				$(inputList[currentIndex]).addClass("gongqiFocus").find("input[type='radio']").focus();
			}
		}
	}

	setFinalValue(value,triggerModified = true)
	{
		if(!value)
			value = this.selectedValue;
		if(!this.props.dataField)
		{
			if(this.props.groupAlias == "" || !this.props.groupAlias)
			{
				var oldValue = this.record;var newValue = value;this.record = value;
			
				if(this.props.control && oldValue != newValue && triggerModified)
				{
					this.props.control.doModifiedEditor(oldValue, newValue);
				}
			}
			this.record = value;
		}
		else
		{
			let changed = false;
			let oldValue = (this.record&&this.props.dataField)?this.record[this.props.dataField]:(this.record?this.record:"");
			let newValue = value;
			if(oldValue != newValue)
				changed = true;
			this.record[this.props.dataField] = newValue;
			//alert("派发");	
			if(changed)	
			{
				RecordsActions.RecordFieldChanged(this.record,this.props.dataField,oldValue,newValue,this);
				if(this.props.control)this.props.control.doFieldModifiedRemote(this.props.dataField,newValue+"",oldValue+"");
			}
			this.updateModifiedTag();
		}
	}

	setValue(value,triggerModified = true)
	{
		if(value==0 || value)
		{
			if(Array.isArray(value))
			{
				this.selectValue(value[0]);
			}
			else
			{
				if(typeof(value) == 'string' && value.indexOf(',') != -1)
				{
					this.selectValue(value.split(',')[0]);
					return;
				}
				let list = this.props.control.getProperty_DataProvider();
				for(let i = 0;i<list.length;i++)
				{
					let item = list[i];
					if(item.value == value || item.value == (value+""))
					{
						this.selectValue(value);
						this.setFinalValue(item.value,triggerModified);
						return;
					}
				}
			}
		}
		else
		{
			throw new Error("EnumEditor.setValue not String");
		}
	}

	setDisplayFieldText(value,triggerModify = true)
	{
		this.setValue(value,triggerModify);
    }
    
	getFormAutoQueryValue()
	{
		return this.selectedValue;
	}

	onMapEditorsHandler(selector,mapEditorValues,moduleInstanceId)
	{
		if((this.props.groupAlias == "" || !this.props.groupAlias) && this.props.moduleInstanceId == moduleInstanceId)
		{
			if(selector!="all" && this.props.xml.name != selector)
				return;
			if(this.props.underQueryGroup && !this.getInQueryGroupNow())
				return;
			if(!this.record||this.record == "")
			{
				mapEditorValues[this.props.xml.name] = this.props.defaultValueForCMD;
			}
			else
			{
				let _record = this.record;
				if(Array.isArray(this.record))
				{
					_record = this.record.join(",");
				}
				mapEditorValues[this.props.xml.name] = _record;
			}
			
		}
		
	}

    getRadioItems(_layout)
	{
        let _options = this.props.options;
        let onFocusHandler=this.enumRadioOnFocusHandler.bind(this);
        let onBlurHandler=this.enumRadioOnBlurHandler.bind(this);
        let onTabHandler = this.enumRadioOnKeyDownHandler.bind(this);
        let inputClass = "minimal";
        let list = [];
        for(let i = 0;i<_options.length;i++)
        {
            let item = _options[i];
            let _value = item.value;
            list.push(<label style={{paddingRight:_layout=="vertical"?'0px':'20px',fontWeight:'200',margin:'0px',marginBottom:_layout=="vertical"?"5px":""}} key={i}>
                        <input onKeyDown={onTabHandler} onFocus={onFocusHandler} onBlur={onBlurHandler} type="radio" 
                                name={this.props.xml.name} className={inputClass} data-serverId={_value} data-index={i}/>
                                {item.label}
                      </label>);
        }

		return list;
	}


    render()
    {
        let list = this.getRadioItems("horizontal");
        let _style = {display:'flex',flexShrink:'0',alignSelf:'stretch',padding:'5px',flexWrap:'wrap'};
        return  <div ref={node=>this.radioContainer=node} style={_style} className="formItemPluginRadio" data-xmlid={this.props.xml.id} id={this.props.xml.name}>
                    {list}
                </div>;    
    }
}


// WEBPACK FOOTER //
// ./src/formItem/FormItemEnumRadioEditor.js